import React, {useEffect, useRef, useState} from "react"

import "./Test.css"

import TestNav from "../../component/Nav/TestNav"
import RightFooter from "../../component/Footer/RightFooter"
import TopHeader from "../../component/Nav/TopHeader"
import GroupTab from "../../component/Test/GroupTab"
import CheckModal from "../../component/Modal/CheckModal"
import {retrieveData, sendFormRequest, sendRequest} from "../../common";
import {ApplyTest} from "../../component/Test/PersonalCreate";
import {useNavigate} from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";

function GroupCode() {
	const navigate = useNavigate()

	const [user, setUser] = useState()

	useEffect(() => {
		retrieveData('user').then(user => {
			setUser(user)
		})
		getProducts()
	}, [])

	const [checkOpen, setCheckOpen] = useState(false)
	const showCheck = () => {
		setCheckOpen(true)
	}

	const [products, setProducts] = useState([])
	const [product, setProduct] = useState()

	const [applyTests, setApplyTests] = useState([{group: '일반 성인'}])
	const [selected, setSelected] = useState([])

	const [name, setName] = useState('')
	const [startDateTime, setStartDateTime] = useState()
	const [endDateTime, setEndDateTime] = useState()

	const [remainCash, setRemainCash] = useState(0)
	const [isLoading, setIsLoading] = useState(false)

	useEffect(() => {
		setRemainCash(product?.remainCash)
	}, [product])

	const getProducts = () => {
		sendRequest('product/product/?group=단체', 'GET', null, data => {
			setProducts(data)
		})
	}

	const increaseApplyTests = () => {
		if (applyTests?.length >= product?.remainCash) {
			alert(`남은 캐시 수 만큼만 목록을 추가할 수 있습니다.`)
			return
		}
		setApplyTests(applyTests.concat({group: '일반 성인'}))
	}

	const deleteSelected = () => {
		let newList = Object.assign([], applyTests)
		console.log(selected)
		newList = newList.filter((item, index) => selected.indexOf(index) === -1)
		setApplyTests(Object.assign([], newList))
	}

	const onSelected = (checked, index) => {
		if (checked) {
			selected.push(index)
			setSelected(Object.assign([], selected))
		} else {
			const idx = selected.indexOf(index)
			if (idx !== -1) {
				selected.splice(idx, 1)
				setSelected(Object.assign([], selected))
			}
		}
	}

	const onChange = (applyTest, index) => {
		applyTests[index] = applyTest
		setApplyTests(applyTests)
	}

	const isValid = () => {
		if (applyTests?.filter((item, index) => selected?.indexOf(index) !== -1).filter(item => !item?.name?.length || !item?.email?.length || !item?.phone?.length || !item?.group?.length)?.length) {
			return false
		}
		return true
	}

	const saveAllApplyTests = () => {
		if (!name?.length) {
			alert('검사 실시 단체 이름을 입력해 주세요.')
			return
		}

		if (!product?.id) {
			alert('검사 종류를 선택해 주세요.')
			return
		}

		if (!isValid()) {
			alert('명단의 필수 값을 모두 채워 주세요.')
			return
		}

		if (isLoading) return

		setIsLoading(true)
		saveApplyTest(applyTests.filter((item, index) => selected?.indexOf(index) !== -1), 0, [])
	}

	const saveApplyTest = (applyTests, index, ids) => {
		if (applyTests?.length - 1 < index) {
			saveGroup(ids)
			return
		}

		sendRequest('test/apply-test/', 'POST', {
			...applyTests[index],
			sender: user?.id,
			test: product?.test?.id,
			product: product?.id,
		}, data => {
			ids.push(data?.id)
			saveApplyTest(applyTests, index + 1, ids)
		})
	}

	const saveGroup = (applyTests) => {
		sendRequest('test/apply-group/', 'POST', {
			applyTests,
			name,
			testType: product?.name,
			startDateTime,
			endDateTime,
			product: product?.id,
		}, data => {
			setCheckOpen(false)
			alert('모두 생성 되었습니다.')
			setIsLoading(false)
			navigate(`/group-code/send-waiting/${data?.id}`)
		})
	}


	const excelUpload = (file) => {
		const formData = new FormData()
		formData.append('file', file)
		sendFormRequest('test/apply-group-excel-upload/', 'POST', formData, data => {
			setApplyTests(data)
		})
	}

	const fileInput = useRef()

	return (
		<>
			<TestNav />
			<div className="container">
				<div className="testContent">
					<TopHeader title={"단체검사 인증코드"} />
					<div className="testWrap">
						<GroupTab isFirst={true} />
						{!products?.length ?
							<div style={{marginTop: 50, fontSize: 20}}>자격 및 수료여부를 등록해주세요.</div>
							:
							<section className="groupCode">
								<form name="groupCode">
									<div className="groupForm">
										<div className="formFlex">
											<div className="formWrap">
												<div className="formItem">
													<div className="formHead">
														<span className="formName">검사 실시 단체</span>
													</div>
												</div>
												<div className="formItem">
													<div className="formBody">
														<span>
															<input type="text" name="" placeholder="단체명을 입력해주세요" required
																		 onChange={e => setName(e.target.value)}/>
														</span>
													</div>
												</div>
											</div>
											<div className="formWrap">
												<div className="formItem">
													<div className="formHead">
														<span className="formName">검사 종류</span>
													</div>
												</div>
												<div className="formItem">
													<div className="formBody">
														<span className="selectWrap">
															<select name="" onChange={e => {
																setProduct(products[e.target.value])
															}}>
																<option defaultValue="">검사 종류를 선택해주세요</option>
																{products?.map((item, index) => {
																	return (
																		<option value={index}>{item?.test?.name}</option>
																	)
																})}
															</select>
														</span>
													</div>
												</div>
											</div>
											<div className="formWrap cash">
												<div className="formItem">
													<div className="formHead">
														<span className="formName">잔여캐시</span>
													</div>
												</div>
												<div className="formItem">
													<div className="formBody">
														<span>
															<input type="text" name="" value={remainCash} readOnly required/>
														</span>
													</div>
												</div>
											</div>
										</div>
										{/*<div className="formWrap">*/}
										{/*	<div className="formItem">*/}
										{/*		<div className="formHead">*/}
										{/*			<span className="formName">검사기간</span>*/}
										{/*		</div>*/}
										{/*	</div>*/}
										{/*	<div className="formItem">*/}
										{/*		<div className="formBody">*/}
										{/*			<span className="dateWrap">*/}
										{/*				<input type="date" onChange={e => setStartDateTime(e.target.value)} /> - <input type="date"  onChange={e => setEndDateTime(e.target.value)}/>*/}
										{/*			</span>*/}
										{/*		</div>*/}
										{/*	</div>*/}
										{/*</div>*/}
									</div>
									{product?.id &&
										<>
											<h4>명단 기재</h4>
											<input ref={fileInput} type='file'
														 accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
														 style={{display: 'none'}} onChange={e => excelUpload(e.target.files[0])}/>
											<div className="tableTab">
												<div className="tableBtn">
													<button type="button" className="addBtn" onClick={increaseApplyTests}>
														목록 추가
													</button>
													<button type="button" className="xlBtn" onClick={e => {
														e.preventDefault()
														fileInput?.current?.click()
													}}>
														엑셀파일 업로드
													</button>
													<button type="button" onClick={e => {
														e.preventDefault()
														deleteSelected()
													}}>선택 삭제
													</button>
													<button type="button" className="downBtn" onClick={e => {
														e.preventDefault()
														window.open('https://incollege.s3.ap-northeast-2.amazonaws.com/media/files/PTS_List.xlsx')
													}}>
														PTS 수검자 단체목록 엑셀 입력양식 다운로드
													</button>
												</div>
												<span>총 {selected?.length}명</span>
											</div>
											<div className="testTableWrap">
												<table className="testTable">
													<colgroup>
														<col width="5%"/>
														<col width="15%"/>
														<col width="10%"/>
														<col width="10%"/>
														<col width="15%"/>
														<col width="10%"/>
														<col width="15%"/>
														<col width="10%"/>
														<col width="10%"/>
													</colgroup>
													<thead>
													<tr>
														<th>
															<div className="formCheckbox">
																<input type="checkbox" id="tableSelectAll" required
																			 onChange={e => {
																				 if (e.target.checked) {
																					 setSelected(applyTests?.map((item, index) => index))
																				 } else {
																					 setSelected([])
																				 }
																			 }}/>
																<label htmlFor="tableSelectAll"></label>
															</div>
														</th>
														<th>검사종류</th>
														<th>
															이름 <span className="required">*</span>
														</th>
														<th>생년월일</th>
														<th>개인고유번호</th>
														<th>소속기관</th>
														<th>
															이메일 <span className="required">*</span>
														</th>
														<th>
															휴대폰 번호 <span className="required">*</span>
														</th>
														<th>
															규준집단 <span className="required">*</span>
														</th>
													</tr>
													</thead>
													<tbody>
													{applyTests?.map((item, index) => {
														return (
															<ApplyTest key={`${item?.name}-${index}`} product={product} applyTest={item} index={index}
																				 onSelected={onSelected} onChange={onChange} selected={selected}/>
														)
													})}
													</tbody>
												</table>
											</div>
										</>
									}
									<div className="testBtnWrap">
										<button type="button">취소</button>
										<button type="button" onClick={() => {
											if (remainCash && remainCash > 0) {
												if (!selected?.length) {
													alert('생성할 항목을 선택해 주세요.')
												} else if (remainCash < selected?.length) {
													alert('캐시가 부족합니다.')
												} else {
													showCheck()
												}
											} else {
												navigate('/purchase-online')
											}
										}} className="keyBtn">
											{remainCash && remainCash > 0 ? '생성하기' : '주문하기'}
										</button>
									</div>
								</form>
							</section>
						}
					</div>
				</div>
			</div>

			{checkOpen && (
				<CheckModal
					setCheckOpen={setCheckOpen}
					warning={`총 ${selected?.length}건의 인증코드를 생성 하시겠습니까?`}
					text={"인증코드 생성 시에는 캐시가 차감되지 않습니다."}
					onConfirm={saveAllApplyTests}
				/>
			)}

			{isLoading && (
				<ClipLoader
					color={'#333'}
					loading={isLoading}
					cssOverride={{
						position: "fixed",
						display: "block",
						margin: "0 auto",
						top: 300,
						left: '50%',
						zIndex: 99999999999
					}}
					size={100}
					aria-label="Loading Spinner"
					data-testid="loader"
				/>
			)}

			<RightFooter />
		</>
	)
}

export default GroupCode
